export default __webpack_public_path__ + "static/media/announcer-defeat.752ab770.mp3";